const values = {
    ALLERGENS: 'Liste des allergènes',
    BASKET: 'Panier',
    CLICK_AND_COLLECT: 'Click & Collect',
    COLLECT_MODE: 'Mode de collecte',
    COOKIES: 'Cookies',
    COOKIES_MANAGEMENT: 'Gestion des cookies',
    CHECKOUT: 'Checkout',
    DELIVERY: 'Delivery',
    FIND_US: 'Nous trouver',
    FORM: 'Formulaire',
    HOME: 'Accueil',
    HOMEPAGE: 'Homepage',
    IDENTIFICATION: 'Identification',
    KINGDOM: 'Kingdom',
    LEGAL_INFO: 'Informations Légales',
    LEGAL_NOTICE: 'Mentions légales',
    LIST_PRODUCTS: 'Liste Produits',
    OFFERS: 'En ce moment',
    PAYMENT: 'Paiement',
    PRIVACY: 'Politique de protection des données',
    PRODUCT_PAGE: 'Page Produit',
    PROMOTION_PAGE: 'Page promo',
    RESTAURANT_CHOICE: 'Choix restaurant',
    SIGN_IN: 'Connexion',
    STORE_LOCATOR: 'Store Locator',
    VALIDATION: 'Validation'
}

export const pageCategoryMapping = (intl: any) => {
    const route = location.pathname

    const message = (id: string) => {
        let formattedMessage = intl.formatMessage({ id })
        return formattedMessage && formattedMessage.toUpperCase()
    }
    let [
        pageCategoryLevel1,
        pageCategoryLevel2,
        pageCategoryLevel3
    ] = route.split('/').filter(item => item)
    let pageTemplate = pageCategoryLevel1

    switch (route.toUpperCase()) {
        //HOMEPAGE
        case '/':
            pageTemplate = pageCategoryLevel1 = values.HOMEPAGE
            break
        //KINGDOM
        case message('routes.kingdom.dashboard'):
            pageTemplate = pageCategoryLevel1 = values.KINGDOM
            pageCategoryLevel2 = values.HOME
            break
        case message('routes.kingdom.card.full'):
        case message('routes.kingdom.privileges.full'):
        case message('routes.kingdom.challenges.full'):
        case message('routes.kingdom.give-points.full'):
        case message('routes.kingdom.points.full'):
        case message('routes.kingdom.orders.full'):
        case message('routes.kingdom.information.full'):
            pageTemplate = pageCategoryLevel1 = values.KINGDOM
            break
        //FORM
        case message('routes.signin'):
        case message('routes.signup'):
        case message('routes.congratulations'):
            pageTemplate = values.FORM
            pageCategoryLevel2 = pageCategoryLevel1
            pageCategoryLevel1 = values.KINGDOM
            break
        case message('routes.clickandcollect.signin.signup'):
            pageTemplate = values.FORM
            pageCategoryLevel1 = values.KINGDOM
            pageCategoryLevel2 = values.SIGN_IN
            break
        //STORE LOCATOR
        case message('routes.restaurants'):
            pageTemplate = values.STORE_LOCATOR
            pageCategoryLevel1 = values.FIND_US
            break
        //DELIVERY
        case message('routes.delivery'):
            pageTemplate = values.DELIVERY
            break
        case message('routes.clickandcollect.restaurant.choice'):
            pageTemplate = pageCategoryLevel1 = values.DELIVERY
            pageCategoryLevel2 = values.RESTAURANT_CHOICE
            break
        case message('routes.clickandcollect.delivery.choice'):
            pageTemplate = pageCategoryLevel1 = values.DELIVERY
            pageCategoryLevel2 = values.COLLECT_MODE
            break
        //LEGAL INFORMATION
        case message('routes.cookies.management'):
            pageTemplate = values.LEGAL_INFO
            pageCategoryLevel1 = values.COOKIES_MANAGEMENT
            break
        case message('routes.privacy.full'):
            pageTemplate = values.LEGAL_INFO
            pageCategoryLevel1 = values.PRIVACY
            pageCategoryLevel2 = undefined
            break
        case message('routes.legalNotice.full'):
            pageTemplate = values.LEGAL_INFO
            pageCategoryLevel1 = values.LEGAL_NOTICE
            pageCategoryLevel2 = undefined
            break
        case message('routes.cookies.full'):
            pageTemplate = values.LEGAL_INFO
            pageCategoryLevel1 = values.COOKIES
            pageCategoryLevel2 = undefined
            break
        case message('routes.allergens'):
            pageTemplate = values.LEGAL_INFO
            pageCategoryLevel1 = values.ALLERGENS
            pageCategoryLevel2 = undefined
            break
        //CLICK & COLLECT
        case message('routes.clickandcollect.catalog'):
            pageTemplate = pageCategoryLevel1 = values.CLICK_AND_COLLECT
            pageCategoryLevel2 = values.LIST_PRODUCTS
            pageCategoryLevel3 = values.HOME
            break
        case message('routes.clickandcollect.menu'):
        case message('routes.clickandcollect.product'):
            pageTemplate = pageCategoryLevel1 = values.CLICK_AND_COLLECT
            pageCategoryLevel2 = values.PRODUCT_PAGE
            break
        case message('routes.clickandcollect.promotions'):
            pageTemplate = pageCategoryLevel1 = values.CLICK_AND_COLLECT
            break
        case message('routes.clickandcollect.cart.summary'):
            pageTemplate = pageCategoryLevel1 = values.CLICK_AND_COLLECT
            pageCategoryLevel2 = values.CHECKOUT
            pageCategoryLevel3 = values.BASKET
            break
        case message('routes.clickandcollect.cart.user.infos'):
            pageTemplate = pageCategoryLevel1 = values.CLICK_AND_COLLECT
            pageCategoryLevel2 = values.CHECKOUT
            pageCategoryLevel3 = values.IDENTIFICATION
            break
        case message('routes.clickandcollect.cart.confirmation'):
            pageTemplate = pageCategoryLevel1 = values.CLICK_AND_COLLECT
            pageCategoryLevel2 = values.CHECKOUT
            pageCategoryLevel3 = values.VALIDATION
            break
        //OTHER
        default:
            if (route.toUpperCase().startsWith(message('routes.custom'))) {
                pageTemplate = pageCategoryLevel1 = values.OFFERS
                break
            }
            if (route.toUpperCase().startsWith(message('routes.catalog'))) {
                pageTemplate = 'En ce moment'
            }
            break
    }

    return {
        page_template: pageTemplate,
        page_category_level_1: pageCategoryLevel1,
        page_category_level_2: pageCategoryLevel2,
        page_category_level_3: pageCategoryLevel3
    }
}
